import React from 'react';

import FileUpload from '../editor/FileUpload'
import Link from '../editor/Link'
import Search from '../editor/Search'

const ABridTimerEditor = (props) => {
    return (
        <div>
            {props.children}
            <hr />
            <div className="form-group">
                <label className="col-sm-3 control-label">Czas w formacie "RRRR-MM-DD GG:mm"</label>
                <div className="col-sm-9">
                    <input type="text" name="time" className="form-control" defaultValue={props.settings.time} placeholder="" />
                </div>
            </div>
        </div>
    );
}


export default ABridTimerEditor;